import React, { useState } from "react";
import {
  Box,
  Button,
  TextField,
  CircularProgress,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import AlertPopup from "../../../../../Components/Bits/AlertPopup";

const DncListManage = () => {
  const [newNumber, setNewNumber] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");

  const AuthDuck = useSelector((state) => state.AuthDuck);
  const { userInfo } = AuthDuck;

  const config = {
    headers: {
      Authorization: `Bearer ${userInfo.token}`,
    },
  };

  const { data, isLoading, refetch } = useQuery(["dnc"], async () => {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/callCentre/dnc`,
      config,
    );
    return res.data;
  });

  const rows =
    data && Array.isArray(data.dncNumbers)
      ? data.dncNumbers.map((item, idx) => ({
          id: item.phone_no ?? idx,
          phone_no: item.phone_no,
        }))
      : [];

  const handleAdd = async () => {
    const trimmed = (newNumber || "").trim();
    if (!trimmed) return;
    setSubmitting(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/callCentre/dnc`,
        { phone_no: trimmed },
        config,
      );
      const json = res.data;
      if (json && json.success) {
        // refetch list after successful add
        await refetch();
        setNewNumber("");
        setAlertMessage("DNC number added successfully");
        setAlertSeverity("success");
        setAlertOpen(true);
      } else {
        // console.error("Failed to add DNC number", json);
        setAlertMessage(json?.message || "Failed to add DNC number");
        setAlertSeverity("error");
        setAlertOpen(true);
      }
    } catch (err) {
      // console.error("Error adding DNC number", err.response?.data);
      setAlertMessage(err.response?.data?.message || "Error adding DNC number");
      setAlertSeverity("error");
      setAlertOpen(true);
    } finally {
      setSubmitting(false);
    }
  };

  const columns = [{ field: "phone_no", headerName: "Phone Number", flex: 1 }];

  return (
    <>
      <Box sx={{ height: 520, width: "100%", p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Typography variant="h6">DNC Numbers</Typography>
          <Box sx={{ flex: 1 }} />
          <TextField
            size="small"
            label="Phone number"
            value={newNumber}
            onChange={(e) => setNewNumber(e.target.value)}
          />
          <Button variant="contained" onClick={handleAdd} disabled={submitting}>
            {submitting ? <CircularProgress size={18} /> : "Add"}
          </Button>
        </Box>

        <DataGrid
          rows={rows}
          columns={columns}
          loading={isLoading}
          pageSize={25}
          rowsPerPageOptions={[10, 25, 50]}
          autoHeight={false}
          disableSelectionOnClick
        />
      </Box>
      <AlertPopup
        open={alertOpen}
        severity={alertSeverity}
        message={alertMessage}
        onClose={() => setAlertOpen(false)}
      />
    </>
  );
};

export default DncListManage;
